/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	$.fn.isOnScreen = function(){

	  var win = $(window);

	  var viewport = {
	    top : win.scrollTop(),
	    left : win.scrollLeft()
	  };

	  viewport.right = viewport.left + win.width();
	  viewport.bottom = viewport.top + win.height();

	  var bounds = this.offset();
	      bounds.right = bounds.left + this.outerWidth();
	      bounds.bottom = bounds.top + this.outerHeight();

	  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

	};

	/// load foundation
	$(document).foundation();

	$(document).ready(function(){

        $('.portal-download-manuals-list .dropdown').click(function(){
            $(this).toggleClass('open');
        });

        $('.language-switcher').click(function(){
        	$('#langselect').toggle();
        });
        $('.profile-dropdown-container').click(function(){
            $('#profile-dropdown').toggle();
        });

        $("[data-circle-graph]").each(function() {
            var $graph = $(this),
            percent = parseInt($graph.data('percent'), 10),
            used = parseInt($graph.data('used'), 10),
            deg = 360*percent/100;
            if(percent > 50) {
                $graph.addClass('gt-50');
            }
            $graph.find('.circle-graph-progress-fill').css('transform','rotate('+ deg +'deg)');
            $graph.find('.circle-graph-percents-number').html(used);
        });




        function checkUSPslider(){
            if ($(window).width() < 600) {
                $('.usp-bar .usps').not('.slick-initialized').slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                autoplaySpeed: 1200,
                                speed: 600,
                            }
                        }
                    ]
                });

            }
        }

        $('.menu-overlay').click(function(){
           $('.menu-overlay').fadeToggle();
           $('.header-right-items').toggleClass('active');
        });

        $('.menu-button').click(function(){
            $('.menu-overlay').fadeToggle();
            $('.header-right-items').toggleClass('active');
        });

        $('.menu-close').click(function(){
            $('.menu-overlay').fadeToggle();
            $('.header-right-items').toggleClass('active');
        });


        checkUSPslider();

        $(window).resize(function () {
            $('.package-mh').matchHeight();
            $('.payment-method').matchHeight();
        });


        $('.portal-download-platform-nav li a').click(function(){
            $('.portal-download-platform-nav li').removeClass('active');

            var parent_li = $(this).parent('li');
            var app = parent_li.attr('data-app');
            $('.single-app').removeClass('active');
            $('.single-app.'+ app +'').addClass('active');

            parent_li.addClass('active');
            return false;
        });

        $('body [data-modal]').on("click", function(){
            var modal_id = $(this).attr('data-modal');
            var el = $('#'+modal_id);
            if (el.length > 0){
                $('#'+modal_id).modal('open');
                if ($('.download_overlay').length > 0){
                    console.log('fading out overlay window');
                    $('.download_overlay').fadeOut();
                }
            } else {
                console.log(modal_id+' modal window not found');
            }
            return false;
        });

        $('#support-modal-form').submit(function(){
            var form = $(this);
            form.hide();
            $('.thank-you-ticket').show();
            $.ajax({
                url: form.attr("action"),
                data: form.serialize(),
                type: 'POST',
                success: function(response){

                }
            });
            return false;
        });

        $('[data-overlay]').click(function(){
            var overlay_id = $(this).attr('data-overlay');
            var el = $('#'+overlay_id);
            if (el.length > 0){
                $('#'+overlay_id).show();
            } else {
                console.log(overlay_id+' overlay window not found');
            }
            
        });

        $('.close_download_overlay').click(function(){
            $('.download_overlay').fadeOut();
        });


        // $(".language-switcher").mouseout(function() {
        //     $('#langselect').hide();
        // });
	});





})(jQuery); // Fully reference jQuery after this point.